import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ProductTableFilterSchema } from './-zod-schema';

export const Route = createFileRoute('/_stacktrace/products/')({
  validateSearch: zodValidator(ProductTableFilterSchema),
});
